export default __webpack_public_path__ + "static/media/bio-sonic.ddc37f6c.png";